import { Log } from "@swivl-mono/types";
import debug from "debug";

export function warn(message?: any, ...optionalParams: any[]) {
  if (message && optionalParams && optionalParams.length > 0) {
    console.warn("⚠️", message, optionalParams);
  } else if (message) {
    console.warn("⚠️", message);
  } else if (optionalParams && optionalParams.length > 0) {
    console.warn("⚠️", optionalParams);
  } else {
    console.warn("⚠️");
  }
}

// For significant messages that are not problems
export function notice(message?: any, ...optionalParams: any[]) {
  if (message && optionalParams && optionalParams.length > 0) {
    console.info("🔷", message, optionalParams);
  } else if (message) {
    console.info("🔷", message);
  } else if (optionalParams && optionalParams.length > 0) {
    console.info("🔷", optionalParams);
  } else {
    console.info("🔷");
  }
}

export class TimeLog {
  static time = console.time;
  static timeEnd = console.timeEnd;
  static timeLog = console.timeLog;
}

export interface SwivlLogger extends debug.Debugger {
  error: debug.Debugger;
  warn: debug.Debugger;
}

export function CreateLogger(log: Log | string, subType?: string) {
  const scope = subType ? `${log}:${subType}` : log;
  const logger = debug(scope) as SwivlLogger;

  logger.error = debug(`${scope}:error`);
  logger.warn = debug(`${scope}:warn`);

  return logger;
}
